const template = (data) => `
<div class="alert alert--error u-mb">
        ${data}
</div>
`
export default template
